import { dollarFormatter, growthTrendFormatter, onlineStatusFormatter } from "../../gridFormatters";

export const cloudGrowthOverview = [
	{
		"field": "resource_name",
		"headerName": "Service",
	},
	{
		"field": "resource_group",
		"headerName": "Resource Group",
	},
	{
		"field": "geography",
		"headerName": "Geography",
	},
	{
		"field": "subscription",
		"headerName": "Subscription",
	},
	{
		"field": "total_cost",
		"headerName": "Cost/Month",
		"type": "numericColumn",
		"cellRenderer": dollarFormatter,
	},
	{
		"field": "growth",
		"headerName": "Growth",
		"cellRenderer": growthTrendFormatter,
		"aggFunc": 'avg'
	},
	{
		"field": "status",
		"headerName": "Status",
		"cellRenderer": onlineStatusFormatter,
	},
]